import { render } from "./CalculationForm.vue?vue&type=template&id=24eb3b50&scoped=true&ts=true"
import script from "./CalculationForm.vue?vue&type=script&lang=ts"
export * from "./CalculationForm.vue?vue&type=script&lang=ts"

import "./CalculationForm.vue?vue&type=style&index=0&id=24eb3b50&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24eb3b50"]])

export default __exports__